export enum IdeaEffect {
  MORALE = 'Morale',
  PRODUCTIVITY = 'Productivity',
  REVENUE = 'Revenue',
  CUSTOMER_SERVICE = 'Customer Service',
  HEALTH_AND_SAFETY = 'Health and Safety',
  QUALITY = 'Quality',
  OTHER = 'Other'
}
